exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SuspenseTimelineContainer___3AvQE {\n  display: flex;\n  flex-direction: row;\n  padding: 0.25rem;\n  align-items: center;\n}\n\n.SuspenseTimelineInput___3F3lx {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n\n.SuspenseTimelineRootSwitcher___3kokU {\n  height: fit-content;\n  max-width: 3rem;\n}\n\n.SuspenseTimelineProgressIndicator___3Pkqy {\n  align-self: center;\n}\n", ""]);

// exports
exports.locals = {
	"SuspenseTimelineContainer": "SuspenseTimelineContainer___3AvQE",
	"SuspenseTimelineInput": "SuspenseTimelineInput___3F3lx",
	"SuspenseTimelineRootSwitcher": "SuspenseTimelineRootSwitcher___3kokU",
	"SuspenseTimelineProgressIndicator": "SuspenseTimelineProgressIndicator___3Pkqy"
};